import { classNames } from '@pwskills/rachnaui/utils';
import React from 'react';
import { IIcon } from '../Icons.types';

const Rocket = (props: IIcon) => {
  const { className = '', ...rest } = props;
  return (
    <svg
      {...rest}
      className={classNames(className)}
      xmlns="http://www.w3.org/2000/svg"
      width={61}
      height={60}
      viewBox="0 0 61 60"
      fill="none"
    >
      <g clipPath="url(#clip0_419_6070)">
        <path
          d="M60.5 30C60.5 13.4315 47.0685 0 30.5 0C13.9315 0 0.5 13.4315 0.5 30C0.5 46.5685 13.9315 60 30.5 60C47.0685 60 60.5 46.5685 60.5 30Z"
          fill="#F0FBF7"
        />
        <path
          d="M31.5425 28.9561L23.6875 36.8111"
          stroke="#46D39A"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.5372 31.11L20.6897 30.2009C20.5935 30.1781 20.505 30.1301 20.4335 30.0618C20.362 29.9935 20.3101 29.9073 20.283 29.8122C20.2559 29.7171 20.2547 29.6165 20.2794 29.5207C20.3042 29.425 20.3541 29.3376 20.4239 29.2675L23.4839 26.2075C23.6901 26.0014 23.969 25.8847 24.2605 25.8825L27.7105 25.8525"
          stroke="#46D39A"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.2537 26.6392L40.152 22.3192C40.2085 22.0484 40.1966 21.7678 40.1175 21.5026C40.0384 21.2375 39.8946 20.9963 39.6989 20.8006C39.5033 20.605 39.2621 20.4612 38.997 20.3821C38.7318 20.303 38.4512 20.2911 38.1804 20.3476L33.8604 21.2459C32.5886 21.51 31.4218 22.1403 30.5037 23.0592L26.9595 26.6026C25.6065 27.9556 24.7262 29.7092 24.4495 31.6026L24.437 31.6859C24.3501 32.2814 24.4034 32.889 24.5929 33.4602C24.7824 34.0314 25.1027 34.5504 25.5283 34.9759C25.9539 35.4013 26.4731 35.7215 27.0444 35.9107C27.6156 36.1 28.2232 36.1531 28.8187 36.0659L28.902 36.0542C30.7954 35.7776 32.549 34.8973 33.902 33.5442L37.4454 30.0009C38.3643 29.0828 38.9946 27.916 39.2587 26.6442L39.2537 26.6392Z"
          stroke="#46D39A"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.0566 21.9043C34.6255 23.6573 36.8436 25.8755 38.5966 28.4443"
          stroke="#46D39A"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.3887 35.9634L30.297 39.8109C30.3197 39.9071 30.3677 39.9955 30.4361 40.067C30.5044 40.1385 30.5906 40.1905 30.6857 40.2176C30.7808 40.2447 30.8814 40.2459 30.9771 40.2211C31.0729 40.1964 31.1603 40.1465 31.2303 40.0767L34.2903 37.0167C34.4967 36.8106 34.6137 36.5317 34.6162 36.24L34.6462 32.79"
          stroke="#46D39A"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_419_6070">
          <rect width={60} height={60} fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Rocket;
